import * as React from 'react';

export const coursesIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18.007"
    height="18"
    viewBox="0 0 18.007 18"
  >
    <g
      id="online-education_1_"
      data-name="online-education (1)"
      transform="translate(0 -0.098)"
    >
      <g id="Group_1220" data-name="Group 1220" transform="translate(0 12.275)">
        <path
          id="Path_1939"
          data-name="Path 1939"
          d="M0,358.752v1.9a.55.55,0,0,0,.528.57H17.479a.55.55,0,0,0,.528-.57v-1.9Z"
          transform="translate(0 -358.752)"
        />
        <path
          id="Path_1940"
          data-name="Path 1940"
          d="M97.2,454.851H93.738v-1.069H90.216v1.069H86.759a.574.574,0,0,0,0,1.141H97.2a.574.574,0,0,0,0-1.141Z"
          transform="translate(-82.974 -450.169)"
        />
      </g>
      <g id="Group_1221" data-name="Group 1221" transform="translate(0 0.098)">
        <path
          id="Path_1941"
          data-name="Path 1941"
          d="M161.395,163.117a.57.57,0,0,1-.2-.037l-3.537-1.337v2.913a9.349,9.349,0,0,0,7.478,0v-2.913L161.6,163.08A.57.57,0,0,1,161.395,163.117Z"
          transform="translate(-152.392 -155.597)"
        />
        <path
          id="Path_1942"
          data-name="Path 1942"
          d="M17.479.1H.528A.55.55,0,0,0,0,.668V12.593H18.007V.668A.55.55,0,0,0,17.479.1ZM15.534,6.766a.529.529,0,1,1-1.055,0V5.42l-.961.393v3.71a.576.576,0,0,1-.3.514,9.051,9.051,0,0,1-8.432,0,.576.576,0,0,1-.3-.514V5.812L2.814,5.128a.588.588,0,0,1,0-1.067l6-2.453a.491.491,0,0,1,.373,0l6,2.453a.571.571,0,0,1,.341.533Z"
          transform="translate(0 -0.098)"
        />
        <path
          id="Path_1943"
          data-name="Path 1943"
          d="M127.743,71.721l4.147,1.843,4.147-1.843-4.147-1.843Z"
          transform="translate(-122.886 -67.225)"
        />
      </g>
    </g>
  </svg>
);

export const directoryIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="17.52"
    viewBox="0 0 23 17.52"
  >
    <g
      id="information_1_"
      data-name="information (1)"
      transform="translate(7.812 0.855)"
    >
      <g
        id="Group_1222"
        data-name="Group 1222"
        transform="translate(-7.812 -0.855)"
      >
        <g id="Group_1401" data-name="Group 1401">
          <g id="folder">
            <path
              id="Path_2187"
              data-name="Path 2187"
              d="M1.348,8.209A2.024,2.024,0,0,1,3.369,6.187h11.68A2.024,2.024,0,0,1,17.07,8.209v.674h1.348V6.637a1.8,1.8,0,0,0-1.8-1.8H8.535v-.9a1.8,1.8,0,0,0-1.8-1.8H1.8A1.8,1.8,0,0,0,0,3.941V16.253L1.348,14.1Z"
              transform="translate(0 -2.145)"
            />
            <path
              id="Path_2188"
              data-name="Path 2188"
              d="M14.463,6.363H2.783a.674.674,0,0,0-.674.674v3.729l1.314-2.1a2.01,2.01,0,0,1,1.715-.951h10V7.037A.674.674,0,0,0,14.463,6.363Z"
              transform="translate(0.586 -0.973)"
            />
            <path
              id="Path_2189"
              data-name="Path 2189"
              d="M17.745,17.906H.675A.674.674,0,0,1,.1,16.875l5.05-8.086a.674.674,0,0,1,.572-.317h15.7a1.572,1.572,0,0,1,1.312,2.438L18.307,17.6A.674.674,0,0,1,17.745,17.906Z"
              transform="translate(0 -0.387)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
